var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.loadComplete,
          expression: "loadComplete",
        },
      ],
      staticClass: "otm-wrap preReg demo-wrap",
    },
    [
      _c("div", { staticClass: "otm-header" }, [
        _c("div", { staticClass: "inner" }, [
          _c("h1", { staticClass: "app-brand" }, [
            _c("div", { staticClass: "brand-logo" }, [
              _c("img", { attrs: { src: _vm.logo } }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "h1-text" }, [
              _c("p", { staticClass: "brand-text" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "test-name" }, [
                _vm._v(_vm._s(_vm.period.name)),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { ref: "otm-body", staticClass: "otm-body ps" }, [
        _c(
          "div",
          { staticClass: "main-wrapper active" },
          [
            _c("StepWrapper", {
              attrs: {
                user: _vm.user,
                step: _vm.step,
                useIdCard: _vm.useIdCard,
                companyName: _vm.companyName,
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }